import { gql } from 'apollo-boost';

export const ENROLLMENTS_QUERY = gql`
query enrollments($brandId: UUID) {
    enrollments{
        edges{
            node{
                id
                courseId
                status
                rating
                review
                percentComplete

                assignments {
                    id
                    status
                    score
                    scormState
                    timeSpent
                    learningObjectId

                    createdAt
                    updatedAt
                    startedAt
                    completedAt

                }

                userCertificate(brandId: $brandId) {
                    id
                    userCertificateUrl
                    courseCertificate {
                        id
                        brand {
                            id
                        }
                    }
                }
            }
        }
    }
}
`;

